module.exports = __webpack_public_path__ + "896e84f548fa85f4b7e40370422509bc.svg";